import * as moment from 'moment';
import UpIcon from '@material-ui/icons/ThumbUp';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DownIcon from '@material-ui/icons/ThumbDown';
import { Button, TextField, Typography } from '@material-ui/core';
import styled from 'styled-components';
import Comment from './Comments';
import Col from 'components/Col';
import Row from 'components/Row';
import Page from 'components/Page';
import EditModal from '../editModal';
import Avatar from 'components/Avatar';
import Separator from 'components/Separator';
import { useActions } from 'helpers/useActions';
import { ForumCard, AvatarName, CommentCount } from '../styled';
import FullScreenLoader from 'components/Loaders/FullScreenLoader';
import { getCurrentPostAction, getSubjects } from '../actions';

import {
  addCommentToForumPostAction,
  deleteForumPostAction,
  deletePostCommentAction,
  editPostCommentAction,
  getForumPostCommentsAction,
  likePostAction,
  likePostCommentAction,
  setCurrentPostAction
} from '../actions';
import { useModal } from 'components/Modal';
import Modal from 'components/Modal';
import LoginAlertModal from '../../../components/loginModal/LoginAlertModal';
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';
import color from 'config/color';
import VerticalSeparator from 'components/VerticalSeparator';

const defaultComment = {
  message: '',
  imageUrl: '',
  key: '',
  date: new Date().getTime(),
  name: '',
  postKey: '',
  uid: ''
};

function ForumPost({ history, match }) {
  // const [state, dispatch] = useReducer(reducer, initialState);
  const [comment, setComment] = useState(defaultComment);
  //for comment editing
  const [editing, setEditing] = useState(false);
  //for forum editing
  const [forumEditing, setForumEditing] = useState(false);

  const likePost = useActions(likePostAction);
  const commentOnPost = useActions(addCommentToForumPostAction);
  const getForumPostComments = useActions(getForumPostCommentsAction);
  const setCurrentPost = useActions(setCurrentPostAction);
  const getCurrentPost = useActions(getCurrentPostAction);
  const likePostComment = useActions(likePostCommentAction);
  const deletePostComment = useActions(deletePostCommentAction);
  const deleteForumPost = useActions(deleteForumPostAction);
  const editPostComment = useActions(editPostCommentAction);
  const getCategories = useActions(getSubjects);
  const authUser = useSelector(state => state.authState.firestoreUser);
  const posts = useSelector(state => state.forumState.posts);
  const postInfo = useSelector(state => state.forumState.detailPost);

  const modal = useModal();

  let liked = false;

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    if (posts[match.params.key]) {
      setCurrentPost(posts[match.params.key]);
    } else {
      getCurrentPost(match.params.key, history, '/forum');
    }
  }, [posts]);

  useEffect(() => {
    if (!postInfo.post || Object.entries(postInfo.post).length === 0) {
      getCurrentPost(match.params.key, history, '/forum');
    }
    //eslint-disable-next-line
  }, [postInfo.post]);

  useEffect(() => {
    getForumPostComments(match.params.key);
    //eslint-disable-next-line
  }, [match.params.key]);

  if (postInfo.post) {
    if (postInfo.post.upVotes) {
      liked = postInfo.post.upVotes.includes(authUser.uid);
    }
  }
  function handleComment(e) {
    e.preventDefault();
    setComment({ ...comment, message: e.target.value });
  }

  function sendComment(e) {
    e.preventDefault();
    if (!editing) {
      comment.uid = authUser.uid;
      comment.postKey = postInfo.post.key;
      comment.name = authUser.name;
      comment.imageUrl = authUser.photo_url;
      commentOnPost(comment);
      setComment({ ...defaultComment });
    } else {
      //update comment
      editPostComment(comment);
      setComment({ ...defaultComment });
      setEditing(false);
    }
  }
  function onEdit() {
    setForumEditing(true);
  }
  function handleClose() {
    setForumEditing(false);
  }

  function deleteForum() {
    deleteForumPost(postInfo.post);
  }

  const check = () => {
    if (authUser.anon) {
      modal.open();
    } else {
      likePost(postInfo.post, authUser.uid);
    }
  };

  function share() {
    window.FB.ui(
      {
        method: 'share',
        href: window.location.href,
        quote: 'Join the conversation on Medilink'
      },
      function(response) {}
    );
  }

  const handleOnClick = () => {
    modal.close();
  };

  const handleLeftIconClick = () => {
    history.push('/forum');
  };

  if (postInfo.loading || !postInfo.post) return <FullScreenLoader />;

  return (
    <Page>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <IndividualForum>
          <BackToForumIcon
            style={{ cursor: 'pointer', color: color.white }}
            onClick={handleLeftIconClick}
          />
          <ForumCard>
            <Row>
              <Avatar marginright="0" image={postInfo.post.imageURL} />
              <Col padding="0" justify="center" style={{ marginLeft: '1em' }}>
                <AvatarName>{postInfo.post.name}</AvatarName>
                <Typography variant="body2" style={{ fontSize: 14 }}>
                  {moment(postInfo.post.date).fromNow()}
                </Typography>
              </Col>
            </Row>
            <Row>
              <div style={{ overflowWrap: 'break-word', width: '100%' }}>
                <Typography
                  style={{
                    whiteSpace: 'pre-wrap',
                    color: color.grey,
                    fontSize: 20
                  }}
                >
                  {postInfo.post.message}
                </Typography>
              </div>
            </Row>
            <Row marginbottom="0">
              <CommentCount>
                <span style={{ paddingRight: 3 }}>
                  {(postInfo.post.upVotes && postInfo.post.upVotes.length) ||
                    '0'}
                </span>
                likes
              </CommentCount>
              <CommentCount>
                <span style={{ paddingRight: 3 }}>
                  {postInfo.post.commentCount}
                </span>
                comments
              </CommentCount>
            </Row>
            <Separator />
            <Row marginbottom="0" style={{ justifyContent: 'space-between' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row'
                }}
              >
                <Button color="primary" onClick={check}>
                  {liked ? (
                    <>
                      <DownIcon style={{ marginRight: 8 }} />
                      Unlike
                    </>
                  ) : (
                    <>
                      <UpIcon style={{ marginRight: 8 }} />
                      Like
                    </>
                  )}
                </Button>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {authUser.uid === postInfo.post.uid && (
                  <>
                    <Button color="primary" onClick={onEdit}>
                      Edit
                    </Button>
                    <VerticalSeparator height="24px" />
                    <Button color="primary" onClick={deleteForum}>
                      Delete
                    </Button>
                  </>
                )}
              </div>
            </Row>
            <Separator />
            {Object.keys(postInfo.comments).map(commentKey => {
              let comment = postInfo.comments[commentKey];
              return (
                <Comment
                  comment={comment}
                  key={commentKey}
                  uid={authUser.uid}
                  likePostComment={likePostComment}
                  deletePostComment={deletePostComment}
                  authUser={authUser}
                  startEditing={edit => {
                    if (edit) {
                      setEditing(true);
                      setComment(comment);
                    }
                  }}
                  onClick={() => modal.open()}
                />
              );
            })}
            {!authUser.anon && (
              <>
                <Separator />
                <Row>
                  <div>
                    <Avatar image={authUser.photo_url} />
                  </div>
                  <form
                    onSubmit={sendComment}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row'
                    }}
                  >
                    <TextField
                      id="outlined-dense"
                      label="Comment"
                      margin="dense"
                      variant="outlined"
                      value={comment.message}
                      style={{ marginTop: 0, width: '100%' }}
                      onInput={handleComment}
                    />
                  </form>
                </Row>
              </>
            )}
          </ForumCard>

          {authUser && authUser.anon && (
            <Modal {...modal.props}>
              <React.Fragment>
                <LoginAlertModal onClick={handleOnClick} history={history} />
              </React.Fragment>
            </Modal>
          )}
          <EditModal
            open={forumEditing}
            forum={postInfo.post}
            handleClose={handleClose}
          />
        </IndividualForum>
      </div>
    </Page>
  );
}

export default ForumPost;

const BackToForumIcon = styled(ChevronLeftIcon)`
  && {
    cursor: pointer;
    border-radius: 60%;
    background-color: ${color.medilinkColor};

    @media (max-width: 960px) {
      margin: 0;
    }
  }
`;

const IndividualForum = styled.div`
  width: 45%;

  @media (max-width: 960px) {
    width: 100%;
  }
`;
